/**
 * @generated SignedSource<<e4bbe555b92649e9c729191825932953>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateReverseInvoiceInput = {
  relatedInvoiceIdentifier: string;
};
export type CreateReverseInvoiceDialogMutation$variables = {
  input: CreateReverseInvoiceInput;
};
export type CreateReverseInvoiceDialogMutation$data = {
  readonly createReverseInvoice: {
    readonly id: string;
    readonly updatedAt: any | null | undefined;
  };
};
export type CreateReverseInvoiceDialogMutation = {
  response: CreateReverseInvoiceDialogMutation$data;
  variables: CreateReverseInvoiceDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Invoice",
    "kind": "LinkedField",
    "name": "createReverseInvoice",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateReverseInvoiceDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateReverseInvoiceDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a1657634fc338923ca4e54050a5cb467",
    "id": null,
    "metadata": {},
    "name": "CreateReverseInvoiceDialogMutation",
    "operationKind": "mutation",
    "text": "mutation CreateReverseInvoiceDialogMutation(\n  $input: CreateReverseInvoiceInput!\n) {\n  createReverseInvoice(input: $input) {\n    id\n    updatedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "4c5fc2d8a86eeff441bde2e8d237b5ff";

export default node;
